import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Col, FloatingLabel, Form, Button } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { GooglePinIcon } from "../../../data/iconImage";
import { emptyValueObjects } from "../../../utils/ManageArray";
import { autoDisplayValue } from "../../../commons/FormatValue";
import TableForm from "../../TableForm";
import ConfirmModal from "../../ConfirmModal";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../../FormComponent";
import CustContractItemsService from "../../../services/custcontractitem.service";

const WorkOrderForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState({ CT: false, CF: false });
  const [validated, setValidated] = useState(false);
  const [contract, setContract] = useState([]);
  const defaultData = {
    Contract_No: "",
    Contract_Start_Date: "",
    Contract_End_Date: "",
    Cus_Id: "",
    GoogleMapLink: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const columns = [
    { name: "PM_No", label: "หมายเลขแผน PM" },
    { name: "PM_Of_Work", label: "PM/ครั้งที่" },
    { name: "Customer.Cus_Code", label: "รหัสสาขา" },
    { name: "Customer.Cus_NumBranch", label: "เลขที่สาขา" },
    { name: "Customer.Cus_Name", label: "ชื่อสาขา", size: 2 },
    { name: "Item.Item_Code", label: "รหัสสินค้า" },
    { name: "Item.Item_Name_TH", label: "รายละเอียดสินค้า", size: 2 },
    { name: "Start_Date", label: "วันที่เริ่มงาน" },
    { name: "End_Date", label: "วันที่เสร็จงาน" }
  ];
  const searchInput = [
    {
      name: "Pm_No",
      label: "หมายเลขแผน PM",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Pm_Of_Work",
      label: "PM/ครั้งที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: "1_5"
    },
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: "4_5",
      disabled: true
    },
    {
      name: "Contract_Start_Date",
      label: "วันที่เริ่มต้นสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      size: null,
      disabled: true
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: 6,
      disabled: true
    },
    {
      name: "Contract_End_Date",
      label: "วันที่สิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true
    },
    {
      name: "Cus_Code",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: "1_5"
    },
    {
      name: "Cus_Name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: "4_5"
    },
    {
      name: "Project_No",
      label: "เลขที่โครงการ",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: null,
      disabled: true
    },
    {
      name: "Admin_Brand",
      label: "ธุรการผู้รับผิดชอบแบรนด์",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Sup_Team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: 9,
      noneAsync: true,
      options: []
    },
    {
      name: "GoogleMapLink",
      label: "Google Map",
      type: "text",
      size: null
    },
    {
      name: "Google_Map_Btn",
      classNames: { col: "ps-0 d-flex align-items-center" },
      type: "button",
      icon: { src: GooglePinIcon, alt: "Google Map Pin Icon" },
      style: { col: { width: "58px" } },
      onClick: () =>
        window.open(
          data.Array[0]?.GoogleMapLink || "https://maps.google.com/",
          "_blank"
        )
    }
  ];

  const getAllCustContractItems = () => {
    setLoading(true);
    CustContractItemsService.getAllCustContractItems()
      .then((response) => setContract(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const floatingSearch = ({ name, label, classNames, options }) => {
    return (
      <SearchSelectComponent
        labelField={label}
        floatingClass={classNames?.label}
        options={options}
        placeholder="โปรดเลือก"
        isInvalid={data.Array?.[0]?.[name] === ""}
        onChange={(change) =>
          setData({
            Array: data.Array.map((item) => ({
              ...item,
              [name]: change?.value
            }))
          })
        }
        value={`${data.Array?.[0]?.[name]}`}
      />
    );
  };

  const floatingInput = ({
    name,
    label,
    type,
    classNames,
    disabled,
    findValue
  }) => {
    return (
      <FloatingControlComponent
        type={type}
        name={name}
        label={label}
        readOnly={readOnly}
        disabled={disabled}
        className={classNames}
        placeholder="โปรดระบุ"
        onChange={({ target }) =>
          setData({
            Array: data.Array.map((item) => ({
              ...item,
              [name]: target.value
            }))
          })
        }
        value={
          autoDisplayValue({
            name,
            type,
            findValue: { ...findValue, value: data.Array[0]?.Contract_No }
          }) || data.Array[0]?.[name]
        }
      />
    );
  };

  const checkValidity = () => {
    if (emptyValueObjects(data.Array, ["Part_File"]).length > 0) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal((prev) => ({ ...prev, CF: !showModal.CF }));
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal((prev) => ({ ...prev, CF: showCallback }));

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    getAllCustContractItems();
  }, []);

  return (
    <Form noValidate validated={validated} onSubmit={handleValidated}>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body as={Row}>
          {searchInput.map((item, idx) => (
            <Col
              key={`${item.name}-${idx}`}
              sm={item.size ?? (item.size === null ? null : 3)}
              className={item.classNames?.col}
              style={item.style?.col}
            >
              {item.type === "button" ? (
                <Button
                  variant="outline-light"
                  className="d-flex align-items-center border-dark rounded-pill"
                  onClick={item.onClick}
                >
                  <Card.Img src={item.icon.src} alt={item.icon.alt} />
                </Button>
              ) : item.type === "select" ? (
                floatingSearch(item)
              ) : (
                floatingInput(item)
              )}
            </Col>
          ))}
        </Card.Body>
      </Card>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2">รายละเอียดรอบแผน PM</Card.Title>
        </Card.Header>

        <Card.Body>
          <TableForm
            editForm
            data={data.Array}
            columns={columns}
            defaultData={defaultData}
            onChangeCallback={(newData) => setData({ Array: newData })}
          />
        </Card.Body>

        <Card.Footer className="p-3 text-end border-top-0 bg-transparent">
          <Button
            type="submit"
            variant="success"
            className="me-2 px-5 py-2 text-dark rounded-pill"
          >
            {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
          </Button>
          <ConfirmModal
            show={showModal.CF}
            data={data}
            content={editData ? "edit" : "save"}
            onSubmitCallback={handleSubmit}
          />

          <Button
            variant="outline-secondary"
            className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
            onClick={() => navigate("/PM_work/create", { state })}
          >
            ยกเลิก
          </Button>
        </Card.Footer>
      </Card>
    </Form>
  );
};

WorkOrderForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default WorkOrderForm;
